import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const Card = ({ bgColor, grayscale, type, headingColor, descriptionColor, fontStyle, link, linkText, faIconClass, category, heading, desc, imgsrc, customHeading }) => {
    const [imgStyle, setImgStyle] = useState({
        // backgroundImage: imgsrc || 'https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-join-us.jpg',
        backgroundImage: `url(${imgsrc || 'https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-join-us.jpg'})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '586px',
        backgroundColor: bgColor || '',
        filter: grayscale ? 'grayscale(100)' : ''
    });
    const [isImgCard, setIsImgCard] = useState(false);

    useEffect(() => {
        if (type === 'img') {
            setIsImgCard(true);
            setImgStyle({ ...imgStyle, backgroundImage: `url(${imgsrc})` });
        } else {
            setIsImgCard(false);
        }
    }, [type, imgStyle.backgroundImage])
    return (
        <>
            <div className="col life-card">
                <div
                    style={isImgCard ? imgStyle : {}}
                >
                    <div className="life-card-top p-4" style={{ backgroundColor: `${type == 'accent' ? "#eaca13" : type == "img" ? "" : bgColor ? bgColor : "#f4f4f4"}` }}>
                    {
                        category && <h6>{category}</h6>
                    }
                        {
                            customHeading ? <div dangerouslySetInnerHTML={{__html: customHeading}}/> :
                                <h2 className='' style={{ color: `${headingColor ? headingColor : '#0d004a'}` }}>
                                    {heading || 'Continuing to give back'}
                                </h2>
                        }
                        <p style={{color: descriptionColor || ""}}>
                            {desc || ' From driving civic engagement with youth to crafting handmade blankets for hospice patients, our associates are driving impact and change.'}
                        </p>
                        {
                            link && linkText ? 
                            <Link to={link || "#"} className='text-decoration-none fs-5 fw-bold text-dark'>{linkText || "Discover"} <i class={`fa-solid ${faIconClass || 'fa-arrow-up-right-from-square'}`}></i></Link> : null
                        }
                    </div>
                    <img src={imgsrc || "https://emt.gartnerweb.com/ngw/globalassets/en/about/images/build-graphics/about-page-give-back.jpg"} alt="" style={{ width: '100%', backgroundColor: bgColor || "" }} className={type == 'img' ? 'd-none' : ""} />
                </div>

            </div>
        </>
    )
}

export default Card;